module.exports = __webpack_public_path__ + "static/img/refresh.3aea9b35.svg";